export default "__VITE_ASSET__CVr1iCXY__"